module.exports = require("highlight.js");


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"highlight.js"}
// module id = 15
// module chunks = 0